import { API } from "aws-amplify";
import { login as loginGqlMutation } from "../../graphql/mutations";
import { GraphQLQuery } from "@aws-amplify/api";
import { LoginInput, LoginMutation, LoginResponse } from "../../API";
import { useCallback } from "react";

export function useLogin() {
    const login = useCallback(
        async (input: LoginInput): Promise<LoginResponse | null> => {
            const result = await API.graphql<GraphQLQuery<LoginMutation>>({
                query: loginGqlMutation,
                variables: { input },
            });

            return result.data?.login || null;
        },
        []
    );

    return { login };
}
